var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PartnerHeader',{attrs:{"img_header":_vm.header_image,"header":"แก้ไขโปรโมชั่นราคาใหม่","link_back":"promotioninformation"}}),_c('MenuPartner'),_c('Promotion_edit_pos_price')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }